import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import DomainListing from '../domainstep/DomainListing'
import * as Config from '../../config/Config'

import {Power3, TweenLite} from "gsap";

import MediaQuery from 'react-responsive'
import {getDomainInCartList} from "../../selectors/CartUtil";

class FurtherDomainListing extends Component {

    static propTypes = {
        onLoadMoreClick: PropTypes.func.isRequired
    }

    componentDidUpdate(oldProps, oldState) {
        if (oldProps.furtherDomainLimit < this.props.furtherDomainLimit) {
            TweenLite.to(window, 1.1, {delay: 0.45, scrollTo: {y: window.scrollY + (Config.DOMAIN_LOAD_MORE_AMOUNT * 30)}, ease: Power3.easeInOut})
        }
    }

    render() {

        if (this.props.queriedDomain === "") {
            return null
        }

        let furtherDomainListingData = []
        let offset = 0
        let staggerOffset = this.props.furtherDomainLimit - Config.DOMAIN_LOAD_MORE_AMOUNT

        const topDomainsAdded = Config.DOMAIN_AMOUNT_TOPDOMAINS
        const queriedDomainOffset = this.props.queriedDomainEnding === '' ? 0 : 1
        const furtherDomainLimit = this.props.furtherDomainLimit


        for (let i = 0; i < topDomainsAdded + furtherDomainLimit - queriedDomainOffset; i++) {


            // find index to skip (queriedDomainEnding in front, not reflected in order)
            if (queriedDomainOffset && !offset && this.props.domainOrder[i] === this.props.queriedDomainEnding) {
                offset = 1
            }

            if ((i + queriedDomainOffset) >= topDomainsAdded) {

                const isAddedToCart = this.props.domainsAddedToCart.includes(this.props.queriedDomain + "." + this.props.domainOrder[i + offset])

                if (!isAddedToCart) {
                    furtherDomainListingData.push(this.props.domainOrder[i + offset])
                } else {
                    staggerOffset--
                }
            }

        }

        return (
            <div className="domain-step__domains-further">
                <MediaQuery maxWidth={759}>{(isMatching) => {
                    return isMatching ? <DomainListing staggerOffset={staggerOffset - 1} listData={furtherDomainListingData} tableLabel="Weitere"/> : <DomainListing staggerOffset={staggerOffset - 1} listData={furtherDomainListingData} tableLabel="Weitere Domainendungen"/>
                }}</MediaQuery>
                <a ref="loadMore" onClick={(e) => {
                    this.props.onLoadMoreClick()
                }} className="domain-step__load-more">
                    weitere laden
                </a>
            </div>
        )

    }

}


const mapStateToProps = (state) => {

    return {
        queriedDomain: state.domainCheck.queriedDomain,
        queriedDomainEnding: state.domainCheck.queriedDomainEnding,
        domainData: state.domainCheck.topLevelDomains.data,
        domainOrder: state.domainCheck.topLevelDomains.order,
        furtherDomainLimit: state.domainCheck.furtherDomainLimit,
        domainsAvailable: state.domainCheck.domainsAvailable[state.domainCheck.queriedDomain],
        domainsGone: state.domainCheck.domainsGone[state.domainCheck.queriedDomain],
        domainsLoading: state.domainCheck.domainsLoading[state.domainCheck.queriedDomain],
        domainsAddedToCart: getDomainInCartList(state)
    }

}


const mapDispatchToProps = (dispatch, getState) => {

    return {}

}

export default connect(mapStateToProps, mapDispatchToProps)(FurtherDomainListing)


/** WEBPACK FOOTER **
 ** ./src/containers/domainstep/FurtherDomainListing.js
 **/